import {
  Box,
  Flex,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Stack,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { useState } from "react";
import { BiPlusMedical } from "react-icons/bi";
import CameraStoriesModal from "./CameraStoriesModal";
import { StoriesModal } from "./StoriesModal";
import { VideoUploadModal } from "./VideoUploadModal";
import { TbCameraPlus } from "react-icons/tb";
import { ImageEditor } from "./ImageEditor";
import MainEditor from "./MainEditor";
import { ImCamera } from "react-icons/im";
import { useNavigate } from "react-router";

export const SelectTypeOfStory = ({ acctType, reload }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [video, setVideo] = useState();

  const [videoSrc, seVideoSrc] = useState("");

  const navigate = useNavigate();

  const handleChange = async (e) => {
    // var reader = new FileReader();
    var url = URL.createObjectURL(e.target.files[0]);
    seVideoSrc(url);
    setVideo(e.target.files[0]);
  };

  return (
    <>
      <Box onClick={onOpen} cursor="pointer">
        <Stack
          w="60px"
          h="60px"
          maxW="60px"
          maxH={"60px"}
          bg="#fff"
          borderRadius={"20px"}
          spacing={"0"}
          color="blue.400"
          align="center"
          justify="center"
          textAlign={"center"}
        >
          <Text fontSize={".8em"}>Add Story</Text>
          <BiPlusMedical />
        </Stack>
      </Box>
      <Modal isOpen={isOpen} onClose={onClose} size="sm" isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalBody p="20px">
            <Flex justify="space-between">
              <Flex
                justify={"center"}
                align="center"
                width="48%"
                textAlign={"center !important"}
                p="10px"
                bg="#f2f2f2"
                color="blue"
                borderRadius="10px"
                cursor={"pointer"}
              >
                <StoriesModal
                  acctType={acctType}
                  reload={() => {
                    onClose();
                    reload();
                  }}
                />
              </Flex>

              <Flex
                justify={"center"}
                align="center"
                width="48%"
                height={"50px"}
                textAlign={"center"}
                p="10px"
                bg="#f2f2f2"
                color="blue"
                borderRadius="10px"
                cursor={"pointer"}
              >
                <CameraStoriesModal
                  acctType={acctType}
                  reload={() => {
                    onClose();
                    reload();
                  }}
                />
              </Flex>

              <Flex
                display={"none"}
                direction={"column"}
                justify={"center"}
                align="center"
                bg="#f2f2f2"
                color={"blue"}
                width="32%"
                textAlign={"center"}
                borderRadius="10px"
                cursor={"pointer"}
              >
                <Input
                  width={0}
                  height={0}
                  id="image"
                  type={"file"}
                  accept="video/mp4"
                  onChange={handleChange}
                />

                <FormLabel
                  htmlFor="image"
                  display={"inline-block"}
                  mt="8px"
                  fontSize=".66em"
                  textAlign={"center"}
                  overflow="hidden"
                >
                  <VideoUploadModal
                    videoSrc={videoSrc}
                    videoFie={video}
                    acctType={acctType}
                    reload={() => {
                      onClose();
                      reload();
                    }}
                  />
                </FormLabel>
              </Flex>
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
